import {GetValues_ForSchema} from "js-vextensions";
import {TriggerSet} from "../@TriggerSet.js";
import {EffectPointer} from "../../@Shared/EffectPointer.js";
import {AddSchema} from "mobx-graphlink";

export class EngineConfig_RealityCheck {
	constructor(initialData: Partial<EngineConfig_RealityCheck>) { Object.assign(this, initialData); }

	enabled: boolean;

	signalRC_triggerSet: TriggerSet;
	signalRC_effect: EffectPointer;
	cueRC_triggerSet: TriggerSet;
	cueRC_effect: EffectPointer;
	waker_effect: EffectPointer;

	reminder_minDelay: number; // in seconds
	reminder_maxDelay: number; // in seconds
	reminder_recordPlayEvents: boolean;
	reminder_maxAmbientNoise: number;
	reminder_effect: EffectPointer;
}
AddSchema("EngineConfig_RealityCheck", {
	properties: {
		enabled: {type: "boolean"},
		
		signalRC_triggerSet: {$ref: "TriggerSet"},
		signalRC_effect: {$ref: "EffectPointer"},
		cueRC_triggerSet: {$ref: "TriggerSet"},
		cueRC_effect: {$ref: "EffectPointer"},
		waker_effect: {$ref: "EffectPointer"},

		reminder_minDelay: {type: "number"},
		reminder_maxDelay: {type: "number"},
		reminder_recordPlayEvents: {type: "boolean"},
		reminder_maxAmbientNoise: {type: "number"},
		reminder_effect: {$ref: "EffectPointer"},
	},
});